<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <button (click)="goBackToList()" mat-icon-button class="text-gray-600 hover:text-gray-800">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h2 class="text-2xl font-bold mb-0">
          {{ isNewStandort ? ('STANDORT_EDIT.TITLE_NEW' | translate) : (isEditMode ? ('STANDORT_EDIT.TITLE_EDIT' | translate) : ('STANDORT_EDIT.TITLE_VIEW' | translate)) }}: 
          <span *ngIf="!isNewStandort && standort">{{ standort.name }}</span>
        </h2>
      </div>

      <div class="flex space-x-2">
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 order-md-1 order-sm-2">
        <!-- MAIN CONTENT START -->

        <!-- Loading State for Existing Location -->
        <div *ngIf="isLoading && !isNewStandort" class="flex justify-center items-center py-8">
          <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
          <span class="ml-4 text-gray-600">{{ 'STANDORT_EDIT.LOADING' | translate }}</span>
        </div>

        <!-- Combined View/Edit Mode -->
        <form [formGroup]="standortForm" [class.opacity-50]="isLoading && !isNewStandort" [class.pointer-events-none]="isLoading && !isNewStandort">
          
          <!-- New Standort Mode - No Tabs -->
          <div *ngIf="isNewStandort" class="step-container d-flex align-items-start flex-column">
            <div class="container-fluid mt-6">
              <div class="form">
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <!-- Nummer -->
                    <div class="form-group">
                      <label class="form-label" for="nummer">{{ 'STANDORT_EDIT.FIELD_NUMBER' | translate }}</label>
                      <div class="form-control bg-gray-100 border border-gray-300 text-gray-600 text-sm rounded-lg block w-full p-2.5">
                        <span class="text-gray-500 italic">{{ 'STANDORT_EDIT.AUTO_NUMBER' | translate }}</span>
                      </div>
                      <small class="text-gray-500 text-xs">{{ 'STANDORT_EDIT.AUTO_NUMBER_HINT' | translate }}</small>
                    </div>

                    <!-- Name -->
                    <div class="form-group">
                      <label class="form-label" for="name">{{ 'STANDORT_EDIT.FIELD_NAME' | translate }}</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="name"
                        formControlName="name"
                        placeholder="Standortname"
                        [class.is-invalid]="isFieldInvalid('name')" />
                      <div *ngIf="isFieldInvalid('name')" class="text-red-500 text-sm">{{ 'STANDORT_EDIT.VALIDATION_NAME' | translate }}</div>
                    </div>

                    <!-- Übergeordneter Kontakt (Client Selection) -->
                    <div class="form-group">
                      <label class="form-label" for="kunde_id">{{ 'STANDORT_EDIT.FIELD_CLIENT' | translate }}</label>
                      <!-- Show selected client when coming from client-edit -->
                      <div *ngIf="selectedClient && kundeId" class="detail-value">
                        {{ displayClientName(selectedClient) }}
                      </div>
                      <!-- Show autocomplete when creating from standalone view -->
                      <div *ngIf="!kundeId">
                        <input
                          type="text"
                          id="kunde_id"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                          [placeholder]="'STANDORT_EDIT.SEARCH_CLIENT' | translate"
                          [matAutocomplete]="clientAutoNew"
                          [formControl]="clientSearchControl"
                          [class.is-invalid]="isFieldInvalid('kunde_id')" />
                        <mat-autocomplete
                          #clientAutoNew="matAutocomplete"
                          [displayWith]="displayClientName">
                          <mat-option *ngFor="let client of filteredClients" [value]="client">
                            {{ displayClientName(client) }}
                          </mat-option>
                        </mat-autocomplete>
                      </div>
                      <div *ngIf="isFieldInvalid('kunde_id')" class="text-red-500 text-sm">{{ 'STANDORT_EDIT.VALIDATION_CLIENT' | translate }}</div>
                    </div>

                    <!-- Status -->
                    <div class="form-group">
                      <label class="form-label" for="status">{{ 'STANDORT_EDIT.FIELD_STATUS' | translate }}</label>
                      <select
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="status"
                        formControlName="status">
                        <option *ngFor="let status of standorteStatusOptions" [value]="status.id">{{ status.label }}</option>
                      </select>
                    </div>

                    <!-- Techniker -->
                    <div class="form-group">
                      <label class="form-label" for="techniker_id">{{ 'STANDORT_EDIT.FIELD_TECHNICIAN' | translate }}</label>
                      <select
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="techniker_id"
                        formControlName="techniker_id"
                        [disabled]="isLoadingTechnicians">
                        <option value="">{{ 'STANDORT_EDIT.NO_TECHNICIAN' | translate }}</option>
                        <option 
                          *ngFor="let technician of availableTechnicians" 
                          [value]="technician.id.toString()">
                          {{ technician.display_name }} ({{ technician.nummer }}) - {{ technician.funktion }}
                        </option>
                      </select>
                      <div *ngIf="isLoadingTechnicians" class="text-gray-500 text-sm mt-1">
                        {{ 'STANDORT_EDIT.LOADING_TECHNICIANS' | translate }}
                      </div>
                      <!-- Warning when no techniker is selected -->
                      <div *ngIf="!isLoadingTechnicians && !standortForm.get('techniker_id')?.value" class="text-amber-600 text-sm mt-1 flex items-center">
                        <mat-icon class="mr-1 text-sm">warning</mat-icon>
                        {{ 'STANDORT_EDIT.WARNING_NO_TECH' | translate }}
                      </div>
                    </div>

                  </div>

                  <div class="col-12 col-lg-6">
                    <!-- Bericht Sprache -->
                    <div class="form-group" *ngIf="false">
                      <label class="form-label" for="bericht_sprache">Bericht Sprache</label>
                      <select
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="bericht_sprache"
                        formControlName="bericht_sprache">
                        <option *ngFor="let sprache of berichtSpracheOptions" [value]="sprache.value">{{ sprache.label }}</option>
                      </select>
                    </div>

                    <!-- Date Fields -->
                    <div class="form-group">
                      <label class="form-label" for="datum_ab_wann">{{ 'STANDORT_EDIT.FIELD_DATE_FROM' | translate }}</label>
                      <input
                        type="date"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="datum_ab_wann"
                        formControlName="datum_ab_wann"
                        placeholder="DD.MM.YYYY" />
                    </div>

                    <div class="form-group">
                      <label class="form-label" for="datum_bis">{{ 'STANDORT_EDIT.FIELD_DATE_TO' | translate }}</label>
                      <input
                        type="date"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="datum_bis"
                        formControlName="datum_bis"
                        placeholder="DD.MM.YYYY" />
                    </div>

                    <!-- Address Fields -->
                    <div class="form-group">
                      <label class="form-label" for="strasse">{{ 'STANDORT_EDIT.FIELD_STREET' | translate }}</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="strasse"
                        formControlName="strasse"
                        [placeholder]="'STANDORT_EDIT.FIELD_STREET' | translate" />
                    </div>

                    <div class="form-group">
                      <label class="form-label" for="plz">{{ 'STANDORT_EDIT.FIELD_ZIP' | translate }}</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="plz"
                        formControlName="plz"
                        [placeholder]="'STANDORT_EDIT.FIELD_ZIP' | translate" />
                    </div>

                    <div class="form-group">
                      <label class="form-label" for="ort">{{ 'STANDORT_EDIT.FIELD_CITY' | translate }}</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="ort"
                        formControlName="ort"
                        [placeholder]="'STANDORT_EDIT.FIELD_CITY' | translate" />
                    </div>

                    <div class="form-group">
                      <label class="form-label" for="land">{{ 'STANDORT_EDIT.FIELD_COUNTRY' | translate }}</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="land"
                        formControlName="land"
                        [placeholder]="'STANDORT_EDIT.FIELD_COUNTRY' | translate" />
                    </div>

                    <!-- Anmeldung Besuche -->
                    <div class="form-group" *ngIf="false">
                      <label class="form-label" for="anmeldung_besuche">Anmeldung Besuche</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="anmeldung_besuche"
                        formControlName="anmeldung_besuche"
                        placeholder="Anmeldung Besuche" />
                    </div>

                    <!-- Bericht Versand -->
                    <div class="form-group" *ngIf="false">
                      <label class="form-label" for="bericht_versand">Bericht Versand</label>
                      <select
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="bericht_versand"
                        formControlName="bericht_versand">
                        <option value="">Bitte wählen...</option>
                        <option *ngFor="let versand of berichtVersandOptions" [value]="versand.value">{{ versand.label }}</option>
                      </select>
                    </div>

                    <!-- Herkunft -->
                    <div class="form-group" *ngIf="false">
                      <label class="form-label" for="herkunft">Herkunft</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="herkunft"
                        formControlName="herkunft"
                        placeholder="Herkunft" />
                    </div>

                    <!-- Anrede -->
                    <div class="form-group" *ngIf="false">
                      <label class="form-label" for="anrede">Anrede</label>
                      <input
                        type="text"
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="anrede"
                        formControlName="anrede"
                        placeholder="Anrede" />
                    </div>

                    <!-- Contact Selection for Bericht E-Mail -->

                    <!-- Bericht E-Mail Contacts (hidden for new standort, only shown in edit mode) -->
                    <div class="form-group" *ngIf="!isNewStandort">
                      <label class="form-label">{{ 'STANDORT_EDIT.REPORT_EMAIL' | translate }}</label>
                      
                      <!-- Add New Contact Section -->
                      <div class="add-contact-section mb-3">
                        <div class="flex gap-2 mb-2">
                          <!-- Contact Dropdown -->
                          <select 
                            (change)="onContactSelectedForListById($event.target.value)" 
                            class="form-control flex-1">
                            <option value="">{{ 'STANDORT_EDIT.SELECT_CONTACT' | translate }}</option>
                            <option *ngFor="let contact of availableContacts" [value]="contact.id">
                              {{ getContactDisplayName(contact) }}
                            </option>
                          </select>
                          
                          <!-- Manual Email Input -->
                          <input 
                            type="email" 
                            [(ngModel)]="newContactEmail" 
                            [ngModelOptions]="{standalone: true}"
                            [placeholder]="'STANDORT_EDIT.EMAIL_PLACEHOLDER' | translate"
                            class="form-control flex-1" />
                          
                          <!-- Add Button -->
                          <button 
                            (click)="addContact()" 
                            [disabled]="!newContactEmail"
                            class="btn btn-primary px-3">
                            {{ 'COMMON.ADD' | translate }}
                          </button>
                        </div>
                        
                        <!-- Name and Anrede inputs -->
                        <div class="flex gap-2 mb-2">
                          <input 
                            [(ngModel)]="newContactName" 
                            [ngModelOptions]="{standalone: true}"
                            [placeholder]="'STANDORT_EDIT.NAME_OPTIONAL' | translate"
                            class="form-control flex-1" />
                          <input 
                            [(ngModel)]="newContactAnrede" 
                            [ngModelOptions]="{standalone: true}"
                            [placeholder]="'STANDORT_EDIT.SALUTATION_OPTIONAL' | translate"
                            class="form-control flex-1" />
                        </div>
                      </div>

                      <!-- Contact List -->
                      <div class="contact-list">
                        <div *ngFor="let contact of reportContacts; let i = index" 
                             class="contact-item flex items-center gap-2 p-2 border rounded mb-2 bg-gray-50">
                          <div class="flex-1">
                            <div class="font-medium">{{ contact.name || 'Unbekannt' }}</div>
                            <div class="text-sm text-gray-600">{{ contact.email }}</div>
                            <div class="text-xs text-gray-500">{{ contact.anrede || 'Keine Anrede' }}</div>
                          </div>
                          <button 
                            (click)="removeContact(i)" 
                            class="text-red-600 hover:text-red-800 px-2">
                            ×
                          </button>
                        </div>
                        
                        <!-- Empty state -->
                        <div *ngIf="reportContacts.length === 0" class="text-gray-500 text-center py-4">
                          Keine Kontakte hinzugefügt
                        </div>
                      </div>
                      
                      <small class="text-gray-500 text-xs">E-Mail-Adressen für den Versand von Berichten</small>
                      
                      <!-- Hidden form control for bericht_email -->
                      <input type="hidden" formControlName="bericht_email" />
                    </div>
                  </div>
                </div>

                <!-- Checkboxes Row - Vertical Layout -->
                <div class="row mt-4" *ngIf="false">
                  <div class="col-12">
                    <div class="space-y-4">
                      <!-- Besuchsbericht -->
                      <div class="form-group">
                        <mat-checkbox
                          id="besuchsbericht"
                          formControlName="besuchsbericht">
                          Besuchsbericht aktiviert
                        </mat-checkbox>
                      </div>

                      <!-- Mit Auswertung Tabelle -->
                      <div class="form-group">
                        <mat-checkbox
                          id="mit_auswertung_tabelle"
                          formControlName="mit_auswertung_tabelle">
                          Mit Auswertung Tabelle
                        </mat-checkbox>
                      </div>

                    </div>
                  </div>
                </div>

                <!-- Bemerkung/Struktur/Anmerkung -->
                <div class="row mt-4">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label" for="bemerkung_struktur_anmerkung">Bemerkung Zutritt Kontakt</label>
                      <textarea
                        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        id="bemerkung_struktur_anmerkung"
                        formControlName="bemerkung_struktur_anmerkung"
                        rows="4"
                        placeholder="Bemerkung Zutritt Kontakt"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons for New Standort -->
            <div class="col-12 mt-6">
              <div class="flex justify-end space-x-4">
                <button 
                  (click)="saveStandort()" 
                  [disabled]="!standortForm.valid || isSaving"
                  mat-raised-button 
                  color="primary">
                  <span *ngIf="isSaving">{{ 'STANDORT_EDIT.BTN_CREATING' | translate }}</span>
                  <span *ngIf="!isSaving">{{ 'STANDORT_EDIT.BTN_CREATE' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Existing Standort Mode - With Tabs -->
          <div *ngIf="!isNewStandort">
            <mat-tab-group #tabGroup animationDuration="0ms" (selectedIndexChange)="onTabChange($event)">
              <mat-tab [label]="'STANDORT_EDIT.TAB_INFO' | translate">
                <div class="step-container d-flex align-items-start flex-column">
                  <div class="container-fluid mt-6">
                    <div class="form">
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <!-- Nummer -->
                          <div class="form-group">
                            <label class="form-label" for="nummer">{{ 'STANDORT_EDIT.FIELD_NUMBER' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.nummer || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <div *ngIf="isEditMode || isNewStandort" class="form-control bg-gray-100 border border-gray-300 text-gray-600 text-sm rounded-lg block w-full p-2.5">
                              <span *ngIf="standort?.nummer; else autoGenerated">
                                {{ standort?.nummer }}
                              </span>
                              <ng-template #autoGenerated>
                                <span class="text-gray-500 italic">{{ 'STANDORT_EDIT.AUTO_NUMBER' | translate }}</span>
                              </ng-template>
                            </div>
                            <small *ngIf="isEditMode || isNewStandort" class="text-gray-500 text-xs">{{ 'STANDORT_EDIT.AUTO_NUMBER_HINT' | translate }}</small>
                          </div>

                          <!-- Name -->
                          <div class="form-group">
                            <label class="form-label" for="name">{{ 'STANDORT_EDIT.FIELD_NAME' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.name || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="name"
                              formControlName="name"
                              placeholder="Standortname"
                              [class.is-invalid]="isFieldInvalid('name')" />
                            <div *ngIf="isFieldInvalid('name')" class="text-red-500 text-sm">{{ 'STANDORT_EDIT.VALIDATION_NAME' | translate }}</div>
                          </div>

                          <!-- Übergeordneter Kontakt (Client Selection) -->
                          <div class="form-group">
                            <div class="flex items-center justify-between mb-1">
                              <label class="form-label" for="kunde_id">{{ 'STANDORT_EDIT.FIELD_CLIENT' | translate }}</label>
                              <button 
                                *ngIf="kundeId && kundeId !== 'new' && kundeId !== '0'"
                                type="button"
                                class="px-2 py-1 text-xs border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                (click)="navigateToClientEdit()">
                                Zum Kunden
                              </button>
                            </div>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ selectedClient ? displayClientName(selectedClient) : '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <div *ngIf="isEditMode || isNewStandort">
                              <!-- Show current client name if available -->
                              <div *ngIf="selectedClient && !isNewStandort" class="mb-2 p-2 bg-gray-50 border border-gray-200 rounded text-sm text-gray-700">
                                <strong>Aktueller Kunde:</strong> {{ displayClientName(selectedClient) }}
                              </div>
                              <input
                                type="text"
                                id="kunde_id_edit"
                                class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                [placeholder]="'STANDORT_EDIT.SEARCH_CLIENT' | translate"
                                [matAutocomplete]="clientAutoEdit"
                                [formControl]="clientSearchControl"
                                [class.is-invalid]="isFieldInvalid('kunde_id')" />
                              <mat-autocomplete
                                #clientAutoEdit="matAutocomplete"
                                [displayWith]="displayClientName">
                                <mat-option *ngFor="let client of filteredClients" [value]="client">
                                  {{ displayClientName(client) }}
                                </mat-option>
                              </mat-autocomplete>
                              <div *ngIf="isFieldInvalid('kunde_id')" class="text-red-500 text-sm">{{ 'STANDORT_EDIT.VALIDATION_CLIENT' | translate }}</div>
                            </div>
                          </div>

                          <!-- Status -->
                          <div class="form-group">
                            <label class="form-label" for="status">{{ 'STANDORT_EDIT.FIELD_STATUS' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.status ? getStatusText(standort.status) : '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <select
                              *ngIf="isEditMode || isNewStandort"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="status"
                              formControlName="status">
                              <option *ngFor="let status of standorteStatusOptions" [value]="status.id">{{ status.label }}</option>
                            </select>
                          </div>

                          <!-- Techniker -->
                          <div class="form-group">
                            <label class="form-label" for="techniker_id">{{ 'STANDORT_EDIT.FIELD_TECHNICIAN' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.techniker_id ? getTechnicianDisplayName(standort.techniker_id) : '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <select
                              *ngIf="isEditMode || isNewStandort"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="techniker_id"
                              formControlName="techniker_id"
                              [disabled]="isLoadingTechnicians">
                              <option value="">{{ 'STANDORT_EDIT.NO_TECHNICIAN' | translate }}</option>
                              <option 
                                *ngFor="let technician of availableTechnicians" 
                                [value]="technician.id.toString()">
                                {{ technician.display_name }} ({{ technician.nummer }}) - {{ technician.funktion }}
                              </option>
                            </select>
                            <div *ngIf="isLoadingTechnicians" class="text-gray-500 text-sm mt-1">
                              {{ 'STANDORT_EDIT.LOADING_TECHNICIANS' | translate }}
                            </div>
                            <!-- Warning when no techniker is selected -->
                            <div *ngIf="!isLoadingTechnicians && !standortForm.get('techniker_id')?.value" class="text-amber-600 text-sm mt-1 flex items-center">
                              <mat-icon class="mr-1 text-sm">warning</mat-icon>
                              {{ 'STANDORT_EDIT.WARNING_NO_TECH' | translate }}
                            </div>
                          </div>

                          <!-- Besuchsbericht -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label">Besuchsbericht</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.besuchsbericht ? 'Ja' : 'Nein' }}
                            </div>
                            <!-- Edit Mode -->
                            <mat-checkbox
                              *ngIf="isEditMode || isNewStandort"
                              id="besuchsbericht"
                              formControlName="besuchsbericht">
                              Besuchsbericht aktiviert
                            </mat-checkbox>
                          </div>

                          <!-- Mit Auswertung Tabelle -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label">Mit Auswertung Tabelle</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.mit_auswertung_tabelle ? 'Ja' : 'Nein' }}
                            </div>
                            <!-- Edit Mode -->
                            <mat-checkbox
                              *ngIf="isEditMode || isNewStandort"
                              id="mit_auswertung_tabelle"
                              formControlName="mit_auswertung_tabelle">
                              Mit Auswertung Tabelle
                            </mat-checkbox>
                          </div>

                          <!-- Bemerkung/Struktur/Anmerkung -->
                          <div class="form-group">
                            <label class="form-label" for="bemerkung_struktur_anmerkung">Bemerkung Zutritt Kontakt</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.bemerkung_struktur_anmerkung || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <textarea
                              *ngIf="isEditMode || isNewStandort"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="bemerkung_struktur_anmerkung"
                              formControlName="bemerkung_struktur_anmerkung"
                              rows="4"
                              placeholder="Bemerkung Zutritt Kontakt"></textarea>
                          </div>

                        </div>

                        <div class="col-12 col-lg-6">
                          <!-- Bericht Sprache -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label" for="bericht_sprache">Bericht Sprache</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ getBerichtSpracheText(standort?.bericht_sprache) || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <select
                              *ngIf="isEditMode || isNewStandort"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="bericht_sprache"
                              formControlName="bericht_sprache">
                              <option *ngFor="let sprache of berichtSpracheOptions" [value]="sprache.value">{{ sprache.label }}</option>
                            </select>
                          </div>

                          <!-- Date Fields -->
                          <div class="form-group">
                            <label class="form-label" for="datum_ab_wann">{{ 'STANDORT_EDIT.FIELD_DATE_FROM' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ getEffectiveDatumAbWann() }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="date"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="datum_ab_wann"
                              formControlName="datum_ab_wann"
                              placeholder="DD.MM.YYYY" />
                          </div>

                          <div class="form-group">
                            <label class="form-label" for="datum_bis">{{ 'STANDORT_EDIT.FIELD_DATE_TO' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.datum_bis || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="date"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="datum_bis"
                              formControlName="datum_bis"
                              placeholder="DD.MM.YYYY" />
                          </div>

                          <!-- Address Fields -->
                          <div class="form-group">
                            <label class="form-label" for="strasse">{{ 'STANDORT_EDIT.FIELD_STREET' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.strasse || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="strasse"
                              formControlName="strasse"
                              [placeholder]="'STANDORT_EDIT.FIELD_STREET' | translate" />
                          </div>

                          <div class="form-group">
                            <label class="form-label" for="plz">{{ 'STANDORT_EDIT.FIELD_ZIP' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.plz || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="plz"
                              formControlName="plz"
                              [placeholder]="'STANDORT_EDIT.FIELD_ZIP' | translate" />
                          </div>

                          <div class="form-group">
                            <label class="form-label" for="ort">{{ 'STANDORT_EDIT.FIELD_CITY' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.ort || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="ort"
                              formControlName="ort"
                              [placeholder]="'STANDORT_EDIT.FIELD_CITY' | translate" />
                          </div>

                          <div class="form-group">
                            <label class="form-label" for="land">{{ 'STANDORT_EDIT.FIELD_COUNTRY' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.land || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="land"
                              formControlName="land"
                              [placeholder]="'STANDORT_EDIT.FIELD_COUNTRY' | translate" />
                          </div>

                          <!-- Anmeldung Besuche -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label" for="anmeldung_besuche">Anmeldung Besuche</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.anmeldung_besuche || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="anmeldung_besuche"
                              formControlName="anmeldung_besuche"
                              placeholder="Anmeldung Besuche" />
                          </div>

                          <!-- Bericht Versand -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label" for="bericht_versand">Bericht Versand</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.bericht_versand || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <select
                              *ngIf="isEditMode || isNewStandort"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="bericht_versand"
                              formControlName="bericht_versand">
                              <option value="">Bitte wählen...</option>
                              <option *ngFor="let versand of berichtVersandOptions" [value]="versand.value">{{ versand.label }}</option>
                            </select>
                          </div>

                          <!-- Herkunft -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label" for="herkunft">Herkunft</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.herkunft || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="herkunft"
                              formControlName="herkunft"
                              placeholder="Herkunft" />
                          </div>

                          <!-- Anrede -->
                          <div class="form-group" *ngIf="false">
                            <label class="form-label" for="anrede">Anrede</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              {{ standort?.anrede || '-' }}
                            </div>
                            <!-- Edit Mode -->
                            <input
                              *ngIf="isEditMode || isNewStandort"
                              type="text"
                              class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              id="anrede"
                              formControlName="anrede"
                              placeholder="Anrede" />
                          </div>

                          <!-- Contact Selection for Bericht E-Mail -->

                          <!-- Bericht E-Mail -->
                          <div class="form-group">
                            <label class="form-label" for="bericht_email">{{ 'STANDORT_EDIT.REPORT_EMAIL' | translate }}</label>
                            <!-- View Mode -->
                            <div *ngIf="!isEditMode && !isNewStandort" class="detail-value">
                              <div *ngIf="reportContacts.length > 0" class="contact-list">
                                <div *ngFor="let contact of reportContacts" class="contact-item p-2 border rounded mb-2 bg-gray-50">
                                  <div class="font-medium">{{ contact.name || 'Unbekannt' }}</div>
                                  <div class="text-sm text-gray-600">{{ contact.email }}</div>
                                  <div class="text-xs text-gray-500">{{ contact.anrede || 'Keine Anrede' }}</div>
                                </div>
                              </div>
                              <div *ngIf="reportContacts.length === 0" class="text-gray-500">
                                Keine Kontakte konfiguriert
                              </div>
                            </div>
                            <!-- Edit Mode (only for existing standorte, not new ones) -->
                            <div *ngIf="isEditMode && !isNewStandort">
                              <!-- Add New Contact Section -->
                              <div class="add-contact-section mb-3">
                                <div class="flex gap-2 mb-2">
                                  <!-- Contact Dropdown -->
                                  <select 
                                    (change)="onContactSelectedForListById($event.target.value)" 
                                    class="form-control flex-1">
                                    <option value="">{{ 'STANDORT_EDIT.SELECT_CONTACT' | translate }}</option>
                                    <option *ngFor="let contact of availableContacts" [value]="contact.id">
                                      {{ getContactDisplayName(contact) }}
                                    </option>
                                  </select>
                                  
                                  <!-- Manual Email Input -->
                                  <input 
                                    type="email" 
                                    [(ngModel)]="newContactEmail" 
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholder]="'STANDORT_EDIT.EMAIL_PLACEHOLDER' | translate"
                                    class="form-control flex-1" />
                                  
                                  <!-- Add Button -->
                                  <button 
                                    (click)="addContact()" 
                                    [disabled]="!newContactEmail"
                                    class="btn btn-primary px-3">
                                    {{ 'COMMON.ADD' | translate }}
                                  </button>
                                </div>
                                
                                <!-- Name and Anrede inputs -->
                                <div class="flex gap-2 mb-2">
                                  <input 
                                    [(ngModel)]="newContactName" 
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholder]="'STANDORT_EDIT.NAME_OPTIONAL' | translate"
                                    class="form-control flex-1" />
                                  <input 
                                    [(ngModel)]="newContactAnrede" 
                                    [ngModelOptions]="{standalone: true}"
                                    [placeholder]="'STANDORT_EDIT.SALUTATION_OPTIONAL' | translate"
                                    class="form-control flex-1" />
                                </div>
                              </div>

                              <!-- Contact List -->
                              <div class="contact-list">
                                <div *ngFor="let contact of reportContacts; let i = index" 
                                     class="contact-item flex items-center gap-2 p-2 border rounded mb-2 bg-gray-50">
                                  <div class="flex-1">
                                    <div class="font-medium">{{ contact.name || 'Unbekannt' }}</div>
                                    <div class="text-sm text-gray-600">{{ contact.email }}</div>
                                    <div class="text-xs text-gray-500">{{ contact.anrede || 'Keine Anrede' }}</div>
                                  </div>
                                  <button 
                                    (click)="removeContact(i)" 
                                    class="text-red-600 hover:text-red-800 px-2">
                                    ×
                                  </button>
                                </div>
                                
                                <!-- Empty state -->
                                <div *ngIf="reportContacts.length === 0" class="text-gray-500 text-center py-4">
                                  {{ 'COMMON.NO_CONTACTS_ADDED' | translate }}
                                </div>
                              </div>
                            </div>
                            <small class="text-gray-500 text-xs">E-Mail-Adressen für den Versand von Berichten</small>
                            
                            <!-- Hidden form control for bericht_email -->
                            <input type="hidden" formControlName="bericht_email" />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Action Buttons for Existing Standort -->
                  <div class="col-12 mt-6">
                    <div class="flex justify-between items-center">
                      <!-- Left side - Delete button (only for existing locations in edit mode) -->
                      <div *ngIf="!isNewStandort && standort && isEditMode">
                        <button 
                          (click)="deleteStandort()" 
                          mat-button
                          color="warn">
                          {{ 'COMMON.DELETE' | translate }}
                        </button>
                      </div>
                      
                      <!-- Right side - Action buttons -->
                      <div class="flex space-x-4 ml-auto">
                        <!-- Edit Mode Button (only for existing locations in view mode) -->
                        <button 
                          *ngIf="!isNewStandort && !isEditMode"
                          (click)="enterEditMode()" 
                          mat-raised-button 
                          color="primary">
                          {{ 'COMMON.EDIT' | translate }}
                        </button>
                        
                        <!-- Cancel Edit Button (only in edit mode for existing locations) -->
                        <button 
                          *ngIf="isEditMode && !isNewStandort"
                          (click)="cancelEdit()" 
                          mat-button>
                          {{ 'COMMON.CANCEL' | translate }}
                        </button>
                        
                        <!-- Save Button (only in edit mode) -->
                        <button 
                          *ngIf="isEditMode && !isNewStandort"
                          (click)="saveStandort()" 
                          [disabled]="!standortForm.valid || isSaving"
                          mat-raised-button 
                          color="primary">
                          <span *ngIf="isSaving">{{ 'STANDORT_EDIT.BTN_SAVING' | translate }}</span>
                          <span *ngIf="!isSaving">{{ 'COMMON.SAVE' | translate }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              
              <!-- Objekt-Struktur Tab -->
              <mat-tab [label]="'STANDORT_EDIT.TAB_STRUCTURE' | translate">
                <div class="objekt-struktur-tab-content">
                  <!-- Object Structure Treetable Component -->
                  <div *ngIf="!isNewStandort && standortId">
                    <app-objekt-struktur-treetable
                      [standortId]="standortId"
                      (indicatorAdded)="onStructureChanged()"
                      (indicatorDeleted)="onStructureChanged()"
                      (indicatorUpdated)="onStructureChanged()"
                      (structureChanged)="onStructureChanged()">
                    </app-objekt-struktur-treetable>
                  </div>
                  <div *ngIf="isNewStandort || !standortId" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">account_tree</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'STANDORT_EDIT.STRUCTURE_EMPTY' | translate }}</p>
                  </div>
                  
                  <!-- Report Generation Dropdown and PDF Export -->
                  <div *ngIf="!isNewStandort && standortId" class="mt-6 px-6">
                    <!-- Report Category Selection and Generate Button -->
                    <div class="flex items-center gap-4 mb-4">
                      <!-- Category Dropdown (Custom Style) -->
                      <div class="flex-none category-dropdown-container" style="position: relative; z-index: 1000;">
                        <div class="relative">
                          <button 
                            type="button"
                            class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                            (click)="toggleCategoryDropdown($event)"
                            [attr.aria-expanded]="isCategoryDropdownOpen"
                            aria-haspopup="listbox">
                            <span *ngIf="getSelectedCategoryOption()" class="flex items-center gap-2">
                              <mat-icon class="w-4 h-4">{{ getSelectedCategoryOption()?.icon }}</mat-icon>
                              <span>{{ getSelectedCategoryOption()?.label }}</span>
                            </span>
                            <span *ngIf="!getSelectedCategoryOption()">Berichttyp auswählen</span>
                            <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                              <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                          </button>

                          <div 
                            *ngIf="isCategoryDropdownOpen"
                            class="absolute left-0 bottom-full mb-2 w-64 origin-bottom-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10"
                            style="z-index: 9999;"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="category-menu-button"
                            tabindex="-1">
                            <div class="py-1" role="none">
                              <!-- Group: Struktur/Pläne -->
                              <button
                                *ngFor="let category of getStrukturCategories()"
                                type="button"
                                class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white disabled:opacity-50 disabled:cursor-not-allowed"
                                role="menuitem"
                                tabindex="-1"
                                [disabled]="!category.available"
                                (click)="selectCategory(category.value, $event)"
                                [class.bg-gray-100]="selectedReportCategory === category.value"
                                [class.text-gray-900]="selectedReportCategory === category.value">
                                <div class="flex items-center gap-2">
                                  <mat-icon class="w-4 h-4">{{ category.icon }}</mat-icon>
                                  <span>{{ category.label }}</span>
                                  <mat-icon *ngIf="!category.available" class="w-4 h-4 text-orange-500 ml-auto">warning</mat-icon>
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Generate Button -->
                      <button
                        (click)="generateStandortReport()"
                        [disabled]="isGeneratingReport"
                        mat-raised-button
                        color="primary"
                        class="bg-green-600 hover:bg-green-700 text-white">
                        <mat-icon class="w-4 h-4 mr-2">description</mat-icon>
                        <span *ngIf="isGeneratingReport">Generiere...</span>
                        <span *ngIf="!isGeneratingReport">Bericht generieren</span>
                      </button>
                    </div>

                    <!-- Trend Analysis Options (shown when trend_analyse is selected) -->
                    <div *ngIf="selectedReportCategory === 'trend_analyse'" class="mb-4 p-4 bg-gray-50 dark:bg-white/5 rounded-lg border border-gray-200 dark:border-white/10">
                      <div class="flex flex-wrap items-end gap-4">
                        <!-- Report Sub-Type -->
                        <div class="flex flex-col">
                          <label class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Berichttyp</label>
                          <select 
                            [(ngModel)]="trendReportType"
                            [ngModelOptions]="{standalone: true}"
                            class="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                            style="color: #111; background-color: #fff;">
                            <option *ngFor="let type of trendReportTypes" [value]="type.value" style="color: #111; background-color: #fff;">{{ type.label }}</option>
                          </select>
                        </div>

                        <!-- Year Selection -->
                        <div class="flex flex-col">
                          <label class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Jahr</label>
                          <select
                            [(ngModel)]="trendSelectedYear"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onTrendYearChange()"
                            class="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                            style="color: #111; background-color: #fff;">
                            <option *ngFor="let year of trendYearOptions" [ngValue]="year" style="color: #111; background-color: #fff;">{{ year }}</option>
                          </select>
                        </div>

                        <!-- Date range display -->
                        <div class="flex flex-col">
                          <label class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Zeitraum</label>
                          <span class="text-sm text-gray-700 dark:text-gray-300 py-2">01.01.{{ trendSelectedYear }} &ndash; 31.12.{{ trendSelectedYear }}</span>
                        </div>
                      </div>

                      <!-- Info text + Preview button -->
                      <div class="flex items-center justify-between mt-3">
                        <div class="text-xs text-gray-500 dark:text-gray-400">
                          Vorjahresvergleich ({{ trendSelectedYear - 1 }}) wird automatisch berechnet.
                        </div>
                        <button
                          type="button"
                          (click)="previewTrendReport()"
                          [disabled]="isGeneratingReport"
                          mat-raised-button
                          color="accent"
                          class="bg-blue-600 hover:bg-blue-700 text-white ml-4">
                          <mat-icon class="w-4 h-4 mr-2">preview</mat-icon>
                          <span *ngIf="isGeneratingReport">Wird geladen...</span>
                          <span *ngIf="!isGeneratingReport">Trendanalyse Vorschau</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>

              <!-- Dokumente Tab -->
              <mat-tab [label]="'STANDORT_EDIT.TAB_PLAN_FILES' | translate">
                <div class="dokumente-tab-content w-11/12 mx-auto">
                  <app-dokumente 
                    *ngIf="!isNewStandort && standort?.id" 
                    [tableName]="'standort'"
                    [recordId]="standort.id?.toString() || ''"
                    [isEmbedded]="true"
                    [parentContext]="'standort-edit'">
                  </app-dokumente>
                  <div *ngIf="isNewStandort || !standort?.id" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">folder</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'STANDORT_EDIT.DOCUMENTS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>

              <!-- Pläne Tab -->
              <mat-tab [label]="'STANDORT_EDIT.TAB_PLANS' | translate">
                <div class="plaene-tab-content">
                  <!-- Embedded Header - Simple design like client-component -->
                  <div class="flex justify-end mb-4 mt-4">
                    <button mat-stroked-button (click)="createPlan()">
                      <mat-icon class="mr-1">add</mat-icon>
                      Neuer Plan
                    </button>
                  </div>

                  <div *ngIf="!isNewStandort && standort?.id">
                    <!-- Plan Table -->
                    <app-plan 
                      [standortId]="standort.id"
                      [isEmbedded]="true"
                      [parentContext]="'standort-edit'">
                    </app-plan>
                  </div>
                  <div *ngIf="isNewStandort || !standort?.id" class="text-center py-8 flex-1 flex items-center justify-center">
                    <div>
                      <mat-icon class="text-gray-400 text-6xl mb-4">map</mat-icon>
                      <p class="text-gray-500 text-lg">{{ 'STANDORT_EDIT.PLANS_EMPTY' | translate }}</p>
                    </div>
                  </div>
                </div>
              </mat-tab>

              <!-- Indikatoren Tab -->
              <mat-tab [label]="'STANDORT_EDIT.TAB_INDICATORS' | translate">
                <div class="indikatoren-tab-content w-11/12 mx-auto">
                  <div class="container-fluid mt-6">
                    
                    <!-- Room Indicators Table - Styled like client-component -->
                    <!-- Filter bar styled like client component -->
                    <div class="flex justify-end items-center mb-2">
                      <div class="relative inline-block text-left">
                        <button type="button"
                                class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                                (click)="toggleStatusMenu()"
                                aria-haspopup="listbox"
                                [attr.aria-expanded]="isStatusMenuOpen">
                          {{ getStatusFilterLabel() }}
                          <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                            <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                          </svg>
                        </button>

                        <div *ngIf="isStatusMenuOpen" class="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div class="py-1">
                            <button type="button" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" (click)="selectStatusFilter(-1)">Alle</button>
                            <button type="button" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" (click)="selectStatusFilter(1)">Aktiv</button>
                            <button type="button" class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50" (click)="selectStatusFilter(0)">Inaktiv</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-4 flow-root">
                      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                          <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
                            <thead>
                              <tr>
                                <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Nr.</th>
                                <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Symbol</th>
                                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Typ/Code</th>
                                <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Position</th>
                                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Ort</th>
                                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">SW</th>
                                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Einheit</th>
                                <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Status</th>
                                <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                                  <span class="sr-only">Actions</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
                              <tr 
                                *ngFor="let indicator of filteredRoomIndicators; let i = index" 
                                class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                                  <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/20">
                                    {{ getFormattedIndicatorNumber(indicator.indikator_number) }}
                                  </span>
                                </td>
                                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                                  <ng-container *ngIf="getSymbolUrlFromIndicator(indicator) as sym">
                                    <div *ngIf="getSymbolColorFromIndicator(indicator) as color" 
                                         class="inline-flex items-center justify-center h-6 w-6"
                                         [style.background-color]="color"
                                         [style.mask-image]="'url(' + sym + ')'"
                                         [style.mask-size]="'contain'"
                                         [style.mask-repeat]="'no-repeat'"
                                         [style.mask-position]="'center'"
                                         [style.-webkit-mask-image]="'url(' + sym + ')'"
                                         [style.-webkit-mask-size]="'contain'"
                                         [style.-webkit-mask-repeat]="'no-repeat'"
                                         [style.-webkit-mask-position]="'center'">
                                    </div>
                                    <img *ngIf="!getSymbolColorFromIndicator(indicator)" 
                                         [src]="sym" 
                                         alt="Symbol" 
                                         class="h-6 w-6 object-contain" />
                                  </ng-container>
                                </td>
                                <td class="whitespace-nowrap px-2 py-2 text-sm font-bold text-gray-900 dark:text-white">
                                  {{ getIndikatorCode(indicator) }}
                                </td>
                                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                                  {{ indicator.name }}
                                </td>
                                <td class="px-3 py-2 whitespace-nowrap">
                                  <div class="text-xs">
                                    <div class="text-gray-500 dark:text-gray-400">{{ indicator.room?.sektion?.gebaeude?.name || '-' }}</div>
                                    <div class="font-medium text-gray-900 dark:text-white">{{ indicator.room?.sektion?.name || '-' }} - {{ indicator.room?.name || '-' }}</div>
                                  </div>
                                </td>
                                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                                  {{ formatSchwellenwertAsInteger(indicator.schwellenwert) }}
                                </td>
                                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                                  {{ indicator.einheit }}
                                </td>
                                <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                                  <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                                        [ngClass]="getStatusBadgeClasses(indicator)">
                                    {{ getStatusTextSimple(indicator) }}
                                  </span>
                                </td>
                                <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                                  <button
                                    (click)="printRoomIndicator(indicator)"
                                    mat-button
                                    color="primary"
                                    class="slim-button">
                                    Drucken
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <!-- Print All Button - Hidden, using dropdown instead -->
                    <!-- <div *ngIf="roomIndicators && roomIndicators.length > 0" class="flex justify-end mt-4 mb-6">
                      <button
                        (click)="printAllRoomIndicators()"
                        mat-raised-button
                        color="primary"
                        class="flex items-center">
                        <mat-icon class="mr-2">print</mat-icon>
                        Alle Drucken
                      </button>
                    </div> -->

                    <!-- No Data Message -->
                    <div *ngIf="!roomIndicators || roomIndicators.length === 0" class="text-center py-8 text-gray-500">
                      <mat-icon class="text-4xl mb-2">sensors</mat-icon>
                      <p>Keine Raum-Indikatoren verfügbar</p>
                    </div>
                  </div>
                  
                  <!-- Report Generation Dropdown and PDF Export -->
                  <div *ngIf="!isNewStandort && standort?.id" class="mt-6 px-6">
                    <!-- Report Category Selection and Generate Button -->
                    <div class="flex items-center gap-4 mb-4">
                      <!-- Category Dropdown (Custom Style) -->
                      <div class="flex-none category-dropdown-container" style="position: relative; z-index: 1000;">
                        <div class="relative">
                          <button 
                            type="button"
                            class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                            (click)="toggleCategoryDropdown($event)"
                            [attr.aria-expanded]="isCategoryDropdownOpen"
                            aria-haspopup="listbox">
                            <span *ngIf="getSelectedCategoryOption()" class="flex items-center gap-2">
                              <mat-icon class="w-4 h-4">{{ getSelectedCategoryOption()?.icon }}</mat-icon>
                              <span>{{ getSelectedCategoryOption()?.label }}</span>
                            </span>
                            <span *ngIf="!getSelectedCategoryOption()">Berichttyp auswählen</span>
                            <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="-mr-1 h-5 w-5 text-gray-400">
                              <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                          </button>

                          <div 
                            *ngIf="isCategoryDropdownOpen"
                            class="absolute left-0 bottom-full mb-2 w-64 origin-bottom-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10"
                            style="z-index: 9999;"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="category-menu-button"
                            tabindex="-1">
                            <div class="py-1" role="none">
                              <!-- Group: Struktur/Pläne -->
                              <button
                                *ngFor="let category of getStrukturCategories()"
                                type="button"
                                class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white dark:focus:bg-white/5 dark:focus:text-white disabled:opacity-50 disabled:cursor-not-allowed"
                                role="menuitem"
                                tabindex="-1"
                                [disabled]="!category.available"
                                (click)="selectCategory(category.value, $event)"
                                [class.bg-gray-100]="selectedReportCategory === category.value"
                                [class.text-gray-900]="selectedReportCategory === category.value">
                                <div class="flex items-center gap-2">
                                  <mat-icon class="w-4 h-4">{{ category.icon }}</mat-icon>
                                  <span>{{ category.label }}</span>
                                  <mat-icon *ngIf="!category.available" class="w-4 h-4 text-orange-500 ml-auto">warning</mat-icon>
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Generate Button -->
                      <button
                        (click)="generateStandortReport()"
                        [disabled]="isGeneratingReport"
                        mat-raised-button
                        color="primary"
                        class="bg-green-600 hover:bg-green-700 text-white">
                        <mat-icon class="w-4 h-4 mr-2">description</mat-icon>
                        <span *ngIf="isGeneratingReport">Generiere...</span>
                        <span *ngIf="!isGeneratingReport">Bericht generieren</span>
                      </button>
                    </div>

                    <!-- Trend Analysis Options (shown when trend_analyse is selected) -->
                    <div *ngIf="selectedReportCategory === 'trend_analyse'" class="mb-4 p-4 bg-gray-50 dark:bg-white/5 rounded-lg border border-gray-200 dark:border-white/10">
                      <div class="flex flex-wrap items-end gap-4">
                        <!-- Report Sub-Type -->
                        <div class="flex flex-col">
                          <label class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Berichttyp</label>
                          <select 
                            [(ngModel)]="trendReportType"
                            [ngModelOptions]="{standalone: true}"
                            class="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                            style="color: #111; background-color: #fff;">
                            <option *ngFor="let type of trendReportTypes" [value]="type.value" style="color: #111; background-color: #fff;">{{ type.label }}</option>
                          </select>
                        </div>

                        <!-- Year Selection -->
                        <div class="flex flex-col">
                          <label class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Jahr</label>
                          <select
                            [(ngModel)]="trendSelectedYear"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onTrendYearChange()"
                            class="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                            style="color: #111; background-color: #fff;">
                            <option *ngFor="let year of trendYearOptions" [ngValue]="year" style="color: #111; background-color: #fff;">{{ year }}</option>
                          </select>
                        </div>

                        <!-- Date range display -->
                        <div class="flex flex-col">
                          <label class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Zeitraum</label>
                          <span class="text-sm text-gray-700 dark:text-gray-300 py-2">01.01.{{ trendSelectedYear }} &ndash; 31.12.{{ trendSelectedYear }}</span>
                        </div>
                      </div>

                      <!-- Info text + Preview button -->
                      <div class="flex items-center justify-between mt-3">
                        <div class="text-xs text-gray-500 dark:text-gray-400">
                          Vorjahresvergleich ({{ trendSelectedYear - 1 }}) wird automatisch berechnet.
                        </div>
                        <button
                          type="button"
                          (click)="previewTrendReport()"
                          [disabled]="isGeneratingReport"
                          mat-raised-button
                          color="accent"
                          class="bg-blue-600 hover:bg-blue-700 text-white ml-4">
                          <mat-icon class="w-4 h-4 mr-2">preview</mat-icon>
                          <span *ngIf="isGeneratingReport">Wird geladen...</span>
                          <span *ngIf="!isGeneratingReport">Trendanalyse Vorschau</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>

              <!-- Projektaufgaben Tab -->
              <mat-tab [label]="'STANDORT_EDIT.TAB_PROJECT' | translate">
                <div class="projektaufgaben-tab-content">
                  <div *ngIf="!isNewStandort && standort?.id">
                    <app-projektaufgabe 
                      [standortId]="standort.id.toString()">
                    </app-projektaufgabe>
                    
                    <!-- Kontrolltermin Preview -->
                    <div class="mt-8">
                      <app-kontrolltermin-preview 
                        [standortId]="standort.id.toString()">
                      </app-kontrolltermin-preview>
                    </div>
                  </div>
                  <div *ngIf="isNewStandort || !standort?.id" class="text-center py-8">
                    <mat-icon class="text-gray-400 w-24 h-24 mb-4">assignment</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'STANDORT_EDIT.PROJECT_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>

              <!-- ABRECHNUNG (Rechnungsvertrag) -->
              <mat-tab *ngIf="!isNewStandort" [label]="'STANDORT_EDIT.TAB_BILLING' | translate">
                <div class="p-4">
                  <div *ngIf="billingLoading" class="text-gray-500 py-6">Lädt…</div>

                  <div *ngIf="!billingLoading && !rechnungsvertrag" class="text-gray-500 py-6">
                    <div>Kein Rechnungsvertrag für diesen Standort vorhanden.</div>
                    <button type="button" (click)="createBilling()" [disabled]="billingSaving"
                      class="mt-3 px-3 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-lg disabled:opacity-50">
                      {{ billingSaving ? 'Legt an…' : 'Rechnungsvertrag anlegen' }}
                    </button>
                  </div>

                  <div *ngIf="!billingLoading && rechnungsvertrag" class="max-w-3xl">
                    <div class="flex items-center justify-between mb-4">
                      <div>
                        <div class="text-sm text-gray-500">Erf.-Nr.</div>
                        <div *ngIf="!billingEdit" class="text-lg font-semibold text-gray-900">{{ rechnungsvertrag.erf_nr }}</div>
                        <input *ngIf="billingEdit" type="text" [(ngModel)]="rechnungsvertrag.erf_nr" [ngModelOptions]="{standalone: true}"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-lg font-semibold rounded-lg block w-full p-2.5" />
                      </div>
                      <div class="flex gap-2">
                        <button type="button" *ngIf="!billingEdit" (click)="billingEdit = true"
                          class="px-3 py-2 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
                          Bearbeiten
                        </button>
                        <button type="button" *ngIf="billingEdit" (click)="saveBilling()" [disabled]="billingSaving"
                          class="px-3 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-lg disabled:opacity-50">
                          {{ billingSaving ? 'Speichert…' : 'Speichern' }}
                        </button>
                        <button type="button" *ngIf="billingEdit" (click)="billingEdit = false; loadBilling(standort?.id?.toString())"
                          class="px-3 py-2 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
                          Abbrechen
                        </button>
                      </div>
                    </div>

                    <!-- Hausverwaltung link -->
                    <div *ngIf="rechnungsvertrag.hausverwaltung" class="mb-4 p-3 bg-blue-50 rounded-lg flex items-center gap-2">
                      <mat-icon class="text-blue-600">apartment</mat-icon>
                      <div>
                        <div class="text-xs text-gray-500">Hausverwaltung (Rechnungsempfänger)</div>
                        <a [routerLink]="['/hausverwaltungen/edit', rechnungsvertrag.hausverwaltung_id]"
                          class="text-blue-700 font-medium hover:underline">{{ rechnungsvertrag.hausverwaltung.name }}</a>
                      </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="form-group">
                        <label class="form-label">Rechnungsintervall</label>
                        <input type="text" [(ngModel)]="rechnungsvertrag.rg_intervall_type" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">Kd-Bestellnr.</label>
                        <input type="text" [(ngModel)]="rechnungsvertrag.kd_bestellnr" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">VK Wert Netto</label>
                        <input type="number" step="0.01" [(ngModel)]="rechnungsvertrag.vk_wert_netto" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">VK Wert Brutto</label>
                        <input type="number" step="0.01" [(ngModel)]="rechnungsvertrag.vk_wert_brutto" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">Zahlungsziel (Tage)</label>
                        <input type="number" [(ngModel)]="rechnungsvertrag.zahlungsziel_tage" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                    </div>

                    <h3 class="text-sm font-semibold text-gray-700 mt-6 mb-2">Rechnungsadresse</h3>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="form-group">
                        <label class="form-label">Zusatzname</label>
                        <input type="text" [(ngModel)]="rechnungsvertrag.rg_adresse_zusatzname" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">zu Handen</label>
                        <input type="text" [(ngModel)]="rechnungsvertrag.rg_adresse_zuhanden" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                      <div class="form-group md:col-span-2">
                        <label class="form-label">Straße</label>
                        <input type="text" [(ngModel)]="rechnungsvertrag.rg_adresse_zeile1" [ngModelOptions]="{standalone: true}"
                          [readonly]="!billingEdit"
                          class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                          [class.bg-gray-100]="!billingEdit" />
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</div>